import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { handleSignOut } from '../../../../store/user/duck';
import { renderHeaderButton } from '../../../../store/headerButtonControl/duck';
import {
  getContentJson,
  getContentLink,
  getLocalContent
} from '../../../../components/StandardContentComponents/utils';
import AppContentContainer from '../../../../components/AppContentContainer/AppContentContainer';
import { tracking } from '../../../../utils/tracking';
import HotTopicContentSlides from '../hotTopic/HotTopicContentSlides';
import './NewHelpCenter.scss';
import HelpCenterHeader from './HelpCenterHeader';
import VideoCard from '../../../../components/VideoCard/VideoCard';
import { Box } from '@mui/material';
import { useWidth } from '../../../../utils/hooks';
import { trackViewership } from '../../../../utils/tracking/index';
import NativeOrWeb from '../../../../utils/native';
import { isSigningClassroomIframe } from '../../../../utils/is-embedded-iframe';
// import _ from 'lodash';

const NewHelpCenterView = props => {
  const { history, location, intl, userDetails, subscriptions } = props;

  const [contents, setContents] = useState([]);
  const [bannerContents, setBannerContents] = useState({});
  const [bannerSideContents, setBannerSideContents] = useState({});

  const w = useWidth();
  const isMD = w === 'md';
  const helpCenterHeaderRef = useRef(null);

  useEffect(() => {
    const isIOSNative = NativeOrWeb.isIOSPlatform();
    const isUserAuthenticated = userDetails && userDetails._id;
    // ENG-1026 iframe is a second SPA: do not bounce to login when the parent session is already live.
    if (!isSigningClassroomIframe() && !isIOSNative && !isUserAuthenticated) {
      history.push({ pathname: '/login', state: { from: '/new_help_center' } });
    }
  }, [userDetails]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getContentJson({
        contentLink: getContentLink('help-center'),
        localContent: process.env.NODE_ENV === 'development' && (await getLocalContent('help-center'))
      });
      const bannerContents = getLayoutContents('banner', data);
      const bannerSideContents = getLayoutContents('banner_side', data);
      setBannerContents(bannerContents);
      setBannerSideContents(bannerSideContents);

      const nextContents = data.filter(item => {
        return !item.layout;
      });
      setContents({ data: nextContents });
    };

    fetchData()
      .then()
      .catch();
  }, []);

  useEffect(() => {
    // user tracking
    tracking('Adviser enter help center');
    trackViewership('help-center', {
      'Page Path': window.location.pathname,
      'Page URL': window.location.href,
      'Page Domain': window.location.hostname,
      Interval: 180000
    });
  }, []);

  const getLayoutContents = (layout, data) => {
    if (data && data?.length > 0 && layout) {
      return data.find(item => item?.layout?.includes(layout));
    }
    return {};
  };

  const handleSetBannerIsPlaying = isPlaying => {
    helpCenterHeaderRef?.current
      ?.getBanner()
      ?.getVideoCard()
      ?.setIsPlaying(isPlaying);
  };

  // const bannerContents = getLayoutContents("banner");
  // const bannerSideContents = getLayoutContents("banner_side");

  return (
    <AppContentContainer>
      <div style={{ paddingTop: 10 }} id="help-center">
        {/* <AladdinHint
          containerProps={{ justify: 'center' }}
          title={intl.formatMessage({ id: 'aladdin-help-center-title' })}
        /> */}
        <HotTopicContentSlides
          toggleDialogShowTags={true}
          useCardRender="video_card"
          header={onToggleItem => {
            return (
              bannerContents &&
              bannerContents?.items?.length > 0 &&
              bannerSideContents &&
              bannerSideContents?.items?.length > 0 && (
                <Box style={{ margin: 16 }}>
                  <HelpCenterHeader
                    ref={helpCenterHeaderRef}
                    bannerContents={bannerContents}
                    bannerSideContents={bannerSideContents}
                    intl={intl}
                    onToggleItem={(item, isOpen) => {
                      onToggleItem(item, isOpen);
                      handleSetBannerIsPlaying(false);
                    }}
                  />
                </Box>
              )
            );
          }}
          cardRender={(itemData, onClick) => {
            // console.log('NewHelpCenterView itemData::: ', itemData, index)
            return (
              <Box style={{ marginRight: 16 }}>
                <VideoCard
                  type="portrait"
                  itemData={itemData}
                  locale={intl.locale}
                  intl={intl}
                  onClick={() => {
                    handleSetBannerIsPlaying(false);
                    onClick?.();
                  }}
                  ContainerProps={{
                    style: {
                      width: isMD ? '168px' : '200px'
                    }
                  }}
                />
              </Box>
            );
          }}
          className="new-help-center"
          history={history}
          location={location}
          intl={intl}
          userDetails={userDetails}
          subscriptions={subscriptions}
          eventType="help center"
          hotTopic={contents}
          SeeMoreProps={{
            className: 'new-help-center',
            rowItemLength: 2
          }}
          HotTopicItemProps={{
            DialogProps: {
              maxWidth: 'md'
            }
          }}
          categoryViewPath="/new_help_center_category"
          tagViewPath="/new_help_center_tag"
        />

        {/*<StandardContentTabPanels*/}
        {/*	{...this.props}*/}
        {/*	contentLink={getContentLink('help-center')}*/}
        {/*	localContent={process.env.NODE_ENV === 'development' && getLocalContent('help-center')}*/}
        {/*	eventType="help center"*/}
        {/*/>*/}
      </div>
    </AppContentContainer>
  );
};

let container = connect(
  // Map state to props
  state => ({
    userDetails: state.user.userDetails,
    subscriptions: state.userSubscription.subscriptions
  }),
  // Map actions to props
  {
    handleSignOut,
    renderHeaderButton
  }
)(NewHelpCenterView);

export default injectIntl(container);
